import { ServiceLink } from '@hub/app/commons/static-links';
import { m } from '@hub/messages';
import { Button, ExternalLink } from '@platform/ui';

export function HelpLinkButton() {
  return (
    <Button size="lg" variant="outline" asChild>
      <ExternalLink href={ServiceLink.Help}>{m.commons_error_page_go_to_help()}</ExternalLink>
    </Button>
  );
}
